import {useState} from 'react';
import {loadStripe} from '@stripe/stripe-js';
import {Elements} from '@stripe/react-stripe-js';
import CheckoutForm from './CheckoutForm';

const CheckoutFormEnvelope = ({amount, userid, upgradeCampaign}) => {
  const [stripePromise] = useState(() => loadStripe(
    window.location.href.indexOf('app.activistmailer') !== -1
    ?
    'pk_live_51RKeHAKQmzGpwU9OvcCc2sMIpIzzZKSIQsY5yDVcusuJed'
    + 'JaNQKMPOMKUIQyUBZPrwEmRXgUBgtg8M9HbIznGxmg00h4jvXc2C'
    :
    'pk_test_51QpCbuP9C8ltmqK55b81k26GV9KYtFhUFvRJL6i4LLZfM5'
    + 'APjRljPXMgN5t25PDnEBEAxe24uecrSDDHjuGGVfks00Bcx1QRaQ'
  ));

  return (
    <div>
      <Elements stripe={stripePromise}>
        <CheckoutForm amount={amount} userid={userid} upgradeCampaign={upgradeCampaign} />
      </Elements>
    </div>
  );
}

export default CheckoutFormEnvelope;
